<div class="block-video">
    <div class="block-video__container">
        @if (fileUrl) {
        <video
            [src]="fileUrl"
            class="video-mss"
            controls
            playsinline
            preload="metadata"
        ></video>
        } @if (videoUrl) {
        <iframe
            [src]="videoUrl"
            class="video-mss"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
        >
        </iframe>
        }
    </div>

    @if (transcript) {
    <div class="transcript">
        <div
            class="transcript__header pointer"
            (click)="toggleTranscript = !toggleTranscript"
        >
            <div class="transcript__read">
                <i class="fa fa-message"></i>
                {{ lang.data["block.video.read_transcript"] }}
            </div>
            <i class="fa fa-chevron-down"></i>
        </div>
        <div
            class="transcript__content"
            [ngClass]="toggleTranscript ? '' : 'd-none'"
            [innerHTML]="transcript"
        ></div>
    </div>
    }
</div>
